import { render, staticRenderFns } from "./BackgroundVariants.vue?vue&type=template&id=54fb0604"
import script from "./BackgroundVariants.vue?vue&type=script&lang=js"
export * from "./BackgroundVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports